<style lang="scss" scoped>
.nav-link {
  cursor: pointer;
}
</style>

<template>
  <li @click="logout()">
    <div class="nav-link"><span>Ausloggen</span></div>
  </li>
</template>

<script lang="babel">
import logout from "@/js/logout";

export default {
  methods: {
    logout() {
      localStorage.setItem(
        this.$store.getters["user/me"].id + "-postcode",
        this.$store.getters["search/filterprop"]("postcode")
      );
      localStorage.setItem(
        this.$store.getters["user/me"].id + "-interested_in_gender",
        this.$store.getters["search/filterprop"]("interested_in_gender")
      );
      this.$store.commit("search/resetPostcode");
      logout("/");
    }
  }
};
</script>
